// Dispatcher-defined teams. Each team has a color the dispatcher picks;
// every driver in the team gets that color tinted across their grid row.
//
// Seeded with a few realistic teams so the demo isn't empty on first
// load. The Teams modal lets the dispatcher add/edit/delete from there.

import { ROSTER } from './mockRoster';

export const TEAM_COLOR_PRESETS = [
  { label: 'Red',    value: '#ef4444' },
  { label: 'Orange', value: '#f97316' },
  { label: 'Gold',   value: '#F9B612' },
  { label: 'Green',  value: '#4CAF50' },
  { label: 'Cyan',   value: '#22d3ee' },
  { label: 'Blue',   value: '#3b82f6' },
  { label: 'Purple', value: '#a855f7' },
  { label: 'Pink',   value: '#ec4899' },
];

// Pick a few drivers from the AM shift for the seed teams.
const am = ROSTER.AM;
const pickIds = (...indices) => indices.map(i => am[i]?.id).filter(Boolean);

// Teams are typically 2 drivers (FWD/AFT pair). Three is uncommon but
// it happens for heavy banks; anything beyond three is essentially
// never built in real ops. The TeamsManagerModal still allows building
// larger groups manually — these are just the realistic defaults.
export const SEED_TEAMS = [
  {
    id: 'team-1',
    name: 'Team 1',
    color: '#ef4444',
    driverIds: pickIds(2, 9),         // 2 drivers
  },
  {
    id: 'team-2',
    name: 'Team 2',
    color: '#4CAF50',
    driverIds: pickIds(11, 22),       // 2 drivers
  },
  {
    id: 'team-3',
    name: 'Team 3',
    color: '#3b82f6',
    driverIds: pickIds(5, 18, 33),    // 3 drivers (the rare bigger one)
  },
];
